import { render, staticRenderFns } from "./canva-button.vue?vue&type=template&id=1ee2b2b2&scoped=true&"
import script from "./canva-button.vue?vue&type=script&lang=js&"
export * from "./canva-button.vue?vue&type=script&lang=js&"
import style0 from "./canva-button.vue?vue&type=style&index=0&id=1ee2b2b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee2b2b2",
  null
  
)

export default component.exports